//import 'ol/ol.css';
import { LineString, MultiPoint, MultiLineString, Point, MultiPolygon, Polygon } from 'ol/geom';
import GeometryType from 'ol/geom/GeometryType';
import { OptionalTracingLayer } from './MainMap';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { ICAMSKey, IMapInteractionConfig, FeatureType, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import * as events from '../Bus/Bus';
import { MapConfigModel, INewGeometryConfig, MapLayerGroupType } from '../Models/MapConfigModels';
import { WKT } from 'ol/format';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { getLength } from 'ol/sphere';
import { Feature } from 'ol';

export enum NewMapGeometryResult {
    none,
    close,
    restart
}

export class MapDrawGeometry {

    // *****************************************************
    // Global variables
    private newWizardState: { featureSelectedCAMSKey?: ICAMSKey, featureSelected?: Feature, drawFeature?: Feature };
    private subscriptionSingleFeatureSelected;
    private subscriptionDrawCompleted;
    private original_config: INewGeometryConfig;
    private eventNewMapGeometryCompleted;
    
    // *****************************************************
    // Constructor
    public constructor(protected map: CAMSMap, protected mapConfigModel: MapConfigModel) {
        var self = this;
    }

    // *****************************************************
    // Public functions
    // ----------------------------------------------------------- //
    // New Maint WIZARD
    public newGeometryWizard_Start = (config: INewGeometryConfig, callback: Function): void => {
        const self = this;

        // Copy values
        self.original_config = config;

        // Check zoom level
        if (self.map.getView().getZoom() < 15) {
            Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "TS_Toastr_ZoomCloserError" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
            if (callback != null) callback(false);
            return;
        }

        // Switch on/off the feature type
        $('#newMaintPanel [data-featuretype]').hide(); // First hide all
        $('#newMaintPanel [data-featuretype="' + config.featureType + '"]').show(); // Next show only the relevant messages

        // Reset everything
        $('#newMaintCloseBtn').off('click'); $('#newMaintCloseBtn').on('click', function () { self.newGeometryWizard_Close(callback) });
        $('#newMaint_CancelBtn').off('click'); $('#newMaint_CancelBtn').on('click', function () { self.newGeometryWizard_Restart(callback) });
        $('#newMaint_SaveBtn').off('click'); $('#newMaint_SaveBtn').on('click', function () { self.newGeometryWizard_Save() });
        $('#newMaint_AddWktBtn').off('click'); $('#newMaint_AddWktBtn').on('click', function () { self.newGeometryWizard_AddWKT() });

        this.newWizardState = { featureSelected: config.featureSelected };
        $('#newMaint_Message2').hide();
        $('#newMaint_Message3').hide();
        $('#newMaint_SaveBtn').hide();
        $('#newMaint_CancelBtn').hide();
        $('#newMaint_AddWktBtn').hide();
        $('#newMaint_Message1').show();
        $('#newMaintPanel').addClass('show');
        $('#useParentGeomMaintBtn').off().hide();
        $('#pointMaintGeomTypeBtn').off().hide();
        $('#lineMaintGeomTypeBtn').off().hide();
        $('#polyMaintGeomTypeBtn').off().hide();
        if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();

        // BIND BUTTONS
        //$('#useParentGeomMaintBtn').on('click', function (e, eventInfo) {
        //    let feature = self.map.getFeatureFromMap(config.data);
        //    step4(feature);
        //});

        if (config.featureType == FeatureType.Maint || config.featureType == FeatureType.Infra) {
            $('#pointMaintGeomTypeBtn').on('click', function (e, eventInfo) { step3(GeometryType.POINT); }).show();
            $('#lineMaintGeomTypeBtn').on('click', function (e, eventInfo) { step3(GeometryType.LINE_STRING); }).show();
            $('#polyMaintGeomTypeBtn').on('click', function (e, eventInfo) { step3(GeometryType.POLYGON); }).show();
        } 

        // START: If a feature is provided then skip step 1, otherwise do step 1
        if (config.data == null) {
            // STEP 1: Open wizzard
            $('#newMaint_Message2').hide();

            // STEP 1: Select Geom
            self.subscriptionSingleFeatureSelected = events.bus.subscribe(events.eventSingleFeatureSelected, m => {
                self.subscriptionSingleFeatureSelected();
                self.newWizardState.featureSelected = m.payload;
                let data = self.map.convertFeatureToCAMSKey(m.payload);
                step2(data);
            });

            events.bus.publish(events.eventStartSingleSelection(config.interactionData))
        }
        else {
            // skip step 1 and go to step 2
            step2(config.data);
        }

        // STEP 2: 
        function step2(data: ICAMSKey) {
            self.newWizardState.featureSelectedCAMSKey = data;
            $('#newMaint_Message1').hide();
            $('#newMaint_Message2').show();
            $('#newMaint_CancelBtn').show();
            $('#newMaint_AddWktBtn').show();

            if (config.skipStep2withGeom != null) {
                step3(config.skipStep2withGeom);
            }
            else {
                // Auto select the point geom
                $('#pointMaintGeomTypeBtn').click();
            }
        }

        // STEP 3: Start drawing
        function step3(geomType: GeometryType) {
            // STEP 4: Draw end
            if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
            self.subscriptionDrawCompleted = events.bus.subscribe(events.eventDrawCompelted, m => {
                step4(m.payload);
            });

            events.bus.publish(events.eventStartDrawSelection([geomType, 15, self.newWizardState.featureSelected, config.createEntityMaxDistanceAway, config.tracingLayer]));
        }

        // STEP 4: Draw end
        function step4(feature: Feature) {
            if (self.newWizardState.drawFeature == null) {
                self.newWizardState.drawFeature = feature;
            }
            else {
                if (feature.getGeometry().getType() == GeometryType.POINT) {
                    if (self.newWizardState.drawFeature.getGeometry().getType() == GeometryType.POINT) {
                        var g1 = self.newWizardState.drawFeature.getGeometry();
                        var p1 = new MultiPoint([(g1 as Point).getCoordinates()]);
                        self.newWizardState.drawFeature.setGeometry(p1);
                    }
                    (self.newWizardState.drawFeature.getGeometry() as MultiPoint).appendPoint((feature.getGeometry() as Point));
                }
                else if (feature.getGeometry().getType() == GeometryType.LINE_STRING) {
                    if (self.newWizardState.drawFeature.getGeometry().getType() == GeometryType.LINE_STRING) {
                        var g2 = self.newWizardState.drawFeature.getGeometry();
                        var p2 = new MultiLineString([(g2 as LineString).getCoordinates()]);
                        self.newWizardState.drawFeature.setGeometry(p2);
                    }
                    (self.newWizardState.drawFeature.getGeometry() as MultiLineString).appendLineString((feature.getGeometry() as LineString));
                }
                else if (feature.getGeometry().getType() == GeometryType.POLYGON) {
                    if (self.newWizardState.drawFeature.getGeometry().getType() == GeometryType.POLYGON) {
                        var g3 = self.newWizardState.drawFeature.getGeometry();
                        var p3 = new MultiPolygon([(g3 as Polygon).getCoordinates()]);
                        self.newWizardState.drawFeature.setGeometry(p3);
                    }
                    (self.newWizardState.drawFeature.getGeometry() as MultiPolygon).appendPolygon((feature.getGeometry() as Polygon));
                }
            }
            $('#newMaint_Message2').hide();
            $('#newMaint_AddWktBtn').hide();
            $('#newMaint_Message3').show();
            $('#newMaint_SaveBtn').show();
        }
    }

    private newGeometryWizard_Save = (): void => {
        var self = this;
        
        self.subscriptionDrawCompleted();
        setTimeout(function () { events.bus.publish(events.eventRemoveAllMapInteractions()); }, 100); // Timeout to prevent a double click zoom in event

        // Construct the object and then load the create new form
        let format = new WKT();
        let geom = this.newWizardState.drawFeature.getGeometry();
        let wkt = format.writeGeometry(geom);
        let data: ICAMSKey = {};
        if (this.newWizardState.featureSelectedCAMSKey != null) data = this.newWizardState.featureSelectedCAMSKey;
        data.wkt = wkt;
        data.metadata = { featureLength: parseFloat(getLength(geom).toFixed(2)) };
        
        events.bus.publish(events.eventNewMapGeometryCompleted([true, data]));

        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
    }

    public newGeometryWizard_Close = (callback: Function): void => {
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true));
        events.bus.publish(events.eventClearAllHighlights());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
        events.bus.publish(events.eventNewMapGeometryCompleted([false, null]));
        if (callback != null) callback(NewMapGeometryResult.close ); // This forces a close of the panel
    }

    public newGeometryWizard_Restart = (callback: Function): void => {
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventClearSelectedFeatures());
        if (this.subscriptionSingleFeatureSelected) this.subscriptionSingleFeatureSelected();
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
        this.newGeometryWizard_StartWithOriginalValues(callback);
        if (callback != null) callback(NewMapGeometryResult.restart);
    }

    private newGeometryWizard_AddWKT = (): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/MapActions/AddWKTText', null, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#mapAddWKTModal', ModalAction.Create);

            // SUBMIT BTN
            $('#mapAddWKTModalSubmitBtn').on("click", function () {
                //var wktStr = "MULTILINESTRING ((304143.65316388704 228518.95661352057, 304161.3805165906 228480.84740594146, 304157.9995828094 228470.00057129655, 304157.9995828094 228458.00355327036, 304161.0009560748 228444.99740066705, 304162.99622156145 228436.99999400927, 304164.0023293402 228432.0015391782, 304161.0009560748 228421.00457533402, 304158.9972155527 228415.99582938847, 304158.9972155527 228405.99891972635, 304162.99622156145 228396.00140470453, 304167.0037026056 228385.00444086036, 304169.9966008356 228379.99630027448, 304171.5711413485 228375.82718819726, 304181.3168267458 228368.72934601558, 304190.99652793864 228364.00088159926, 304193.0002684607 228356.0028695818, 304197.9969072128 228336.9982079654, 304207.99805439264 228310.9961938732, 304214.00019556377 228277.99561658592, 304217.9992015725 228250.00317988452, 304221.0005748379 228226.00006343704, 304218.9968343158 228193.99954033177, 304227.00271600904 228168.99636970225, 304246.997140693 228099.99626330097, 304255.0030223862 228076.00343796797))";

                var wktStr = $('#mapAddWKTModal [name="WKTText"]').val();
                if (wktStr == null || wktStr == undefined) {
                    toastr.error("Error parsing WKT!");
                    return;
                }

                var allowedGeomTypes = [GeometryType.POINT, GeometryType.MULTI_POINT, GeometryType.LINE_STRING, GeometryType.MULTI_LINE_STRING, GeometryType.POLYGON, GeometryType.MULTI_POLYGON];
                events.bus.publish(events.eventAddWKTtoEditLayer([wktStr.toString(), true, allowedGeomTypes, function (f) {
                    if (f == null) {
                        toastr.error("Error parsing WKT!");
                        return;
                    }

                    self.newWizardState.drawFeature = f;

                    Utilities.GetModal('#mapAddWKTModal', ModalAction.Hide);
              
                    $('#newMaint_SaveBtn').show();
                    $('#newMaint_AddWktBtn').hide();
                }]));
            });

            // CANCEL BTN
            $('[name=mapAddWKTModalCancelBtn]').on("click", function () {
                Utilities.GetModal('#mapAddWKTModal', ModalAction.Hide);

                events.bus.publish(events.eventRemoveAllMapInteractions());
                events.bus.publish(events.eventClearAllHighlights());
                events.bus.publish(events.eventClearSelectedFeatures());
                if (self.subscriptionSingleFeatureSelected) self.subscriptionSingleFeatureSelected();
                if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();
                self.newGeometryWizard_StartWithOriginalValues(null);
            });
        });
    }

    private newGeometryWizard_StartWithOriginalValues = (callback: Function): void => {
        var self = this;
        self.newGeometryWizard_Start(self.original_config, callback);
    }


    public redrawGeometry = (data: ICAMSKey, featureSelected?: Feature): void => {
        const self = this;
        var url, postData;

        // Make sure the various layers are turned on
        switch (data.featureType) {
            case FeatureType.Maint:
                url = '/Maint/UpdateMaintGeom';
                events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Maint, true]));
                postData = { maintCode: data.code };
                break;

            case FeatureType.Infra:
                url = '/Infra/UpdateInfraGeom';
                events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Infra, true]));
                postData = { infraCode: data.code };
                break;

            case FeatureType.Route:
                url = '/Route/UpdateRouteGeom';
                events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Route, true]));
                postData = { routeCode: data.code };
                break;

            case FeatureType.Land:
                url = '/Land/UpdateLandGeom';
                events.bus.publish(events.eventMapLayerVisibilitySwitch([MapLayerGroupType.Land, true]));
                postData = { landCode: data.code };
                break;
        }
        
        // Capture the end process
        self.eventNewMapGeometryCompleted = events.bus.subscribe(events.eventNewMapGeometryCompleted, e => {
            self.eventNewMapGeometryCompleted();
            if (e.payload[0] == true) {
                postData.wkt = e.payload[1].wkt;
                $.post(url, postData,
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated geometry!');
                                events.bus.publish(events.eventZoomToWKTandHighlight([[data.wkt], true, true, data.featureType]));
                                events.bus.publish(events.eventNewMapGeometryClose(null));
                                events.bus.publish(events.eventRefreshMapLayer(data.featureType));

                                switch (data.featureType) {
                                    case FeatureType.Maint: events.bus.publish(events.eventOpenMaintEditPanel(data)); break;
                                    case FeatureType.Infra: events.bus.publish(events.eventOpenInfraEditPanel([data,null])); break;
                                    case FeatureType.Route: events.bus.publish(events.eventOpenRouteEditPanel(data)); break;
                                    case FeatureType.Land: events.bus.publish(events.eventOpenLandEditPanel(data)); break;
                                }
                            }
                            else {
                                toastr.error('Failed to update item!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });


            }
        });

        // Start the process
        let interactionData: IMapInteractionConfig = { zoomToSelectedFeatures: false, addToExistingSelection: false };
        let config: INewGeometryConfig = { data: data, featureType: data.featureType, interactionData: interactionData, createEntityMaxDistanceAway: self.mapConfigModel.createEntityMaxDistanceAway, featureSelected: featureSelected };
        if (data.featureType == FeatureType.Route) config.skipStep2withGeom = GeometryType.LINE_STRING;
        else if (data.featureType == FeatureType.Land) config.skipStep2withGeom = GeometryType.POLYGON;
        events.bus.publish(events.eventNewMapGeometryStart([config, null]));
    }
}




